
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts/AuthContext';
import { createCampaignInDb } from './services/db/createCampaignService';
import { useTermsAcceptance } from './useTermsAcceptance';

export const useCampaignCreation = (
  setShowPayment?: (show: boolean) => void,
  setCurrentCampaignId?: (id: string | null) => void
) => {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const { toast } = useToast();
  
  // Get terms acceptance functionality
  const { 
    showTerms, 
    setShowTerms, 
    isSubmitting: isTermsSubmitting, 
    handleAcceptTerms: termsAcceptHandler 
  } = useTermsAcceptance(setShowPayment);
  
  // Handler for accepting terms
  const handleAcceptTerms = async () => {
    console.log("Campaign creation: handle accept terms triggered");
    
    try {
      // Simply pass to terms handler - no campaign creation at this stage
      await termsAcceptHandler();
    } catch (error) {
      console.error("Error in campaign creation terms handler:", error);
      toast({
        title: "Error",
        description: "There was a problem processing your request. Please try again.",
        variant: "destructive"
      });
    }
  };
  
  return {
    isLoading,
    showTerms,
    setShowTerms,
    isTermsSubmitting,
    handleAcceptTerms
  };
};
